import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { Stack } from "components/layout/reusableLayouts";
import { PaymentLinkAvailability } from "enums/PaymentLink";

const DEFAULT_MESSAGES: Record<PaymentLinkAvailability, string> = {
  [PaymentLinkAvailability.AVAILABLE]: "payLink.UnavailableGeneric",
  [PaymentLinkAvailability.INACTIVE]: "payLink.UnavailableInactive",
  [PaymentLinkAvailability.EXPIRED]: "payLink.UnavailableExpired",
};

interface PayLinkUnavailableProps {
  availability: PaymentLinkAvailability;
  inactiveMessage?: string;
}

const PayLinkUnavailable: React.FC<PayLinkUnavailableProps> = ({
  availability,
  inactiveMessage,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Stack sx={{ gap: "var(--space-3)", textAlign: "center" }}>
        <Typography variant="h5">{t("payLink.UnavailableTitle")}</Typography>
        <Typography variant="body1">
          {inactiveMessage ||
            t(DEFAULT_MESSAGES[availability] || DEFAULT_MESSAGES.AVAILABLE)}
        </Typography>
      </Stack>
    </>
  );
};

export default PayLinkUnavailable;
